"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbitControlsManager = void 0;
var GlobalUtils_js_1 = __importDefault(require("../../../../../../shared/util/GlobalUtils.js"));
var OrbitControlsEventDistribution_1 = require("./OrbitControlsEventDistribution");
var OrbitControlsLogic_1 = require("./OrbitControlsLogic");
var OrbitControlsHooks_1 = require("./OrbitControlsHooks");
var HooksAndNotifiers_1 = require("../../../../helpers/HooksAndNotifiers");
var OrbitControlsManager = /** @class */ (function () {
    // #endregion Properties (3)
    // #region Constructors (1)
    function OrbitControlsManager(_settings, _cameraControls, _triggerRender, _logWarning) {
        this._settings = _settings;
        this._cameraControls = _cameraControls;
        this._triggerRender = _triggerRender;
        this._logWarning = _logWarning;
        // #region Properties (3)
        this._globalUtils = GlobalUtils_js_1.default;
        this._cameraLogic = new OrbitControlsLogic_1.OrbitControlsLogic(this._settings, this._cameraControls);
        this._cameraEventDistribution = new OrbitControlsEventDistribution_1.OrbitControlsEventDistribution(this._settings, this._cameraControls, this._cameraLogic);
        this._cameraControls.registerCameraControls(this);
        HooksAndNotifiers_1.registerHooksAndNotifiers(this, this._settings, OrbitControlsHooks_1.OrbitControlsHooks, OrbitControlsHooks_1.OrbitControlsNotifiers);
    }
    // #endregion Constructors (1)
    // #region Public Methods (12)
    OrbitControlsManager.prototype.isWithinRestrictions = function (position, target) {
        return this._cameraLogic.isWithinRestrictions(position, target);
    };
    OrbitControlsManager.prototype.onKeyDown = function (event) {
        this._cameraEventDistribution.onKeyDown(event);
    };
    OrbitControlsManager.prototype.onMouseDown = function (event) {
        this._cameraEventDistribution.onMouseDown(event);
    };
    OrbitControlsManager.prototype.onMouseMove = function (event) {
        this._cameraEventDistribution.onMouseMove(event);
    };
    OrbitControlsManager.prototype.onMouseUp = function (event) {
        this._cameraEventDistribution.onMouseUp(event);
    };
    OrbitControlsManager.prototype.onMouseWheel = function (event) {
        this._cameraEventDistribution.onMouseWheel(event);
    };
    OrbitControlsManager.prototype.onTouchEnd = function (event) {
        this._cameraEventDistribution.onTouchEnd(event);
    };
    OrbitControlsManager.prototype.onTouchMove = function (event) {
        this._cameraEventDistribution.onTouchMove(event);
    };
    OrbitControlsManager.prototype.onTouchStart = function (event) {
        this._cameraEventDistribution.onTouchStart(event);
    };
    OrbitControlsManager.prototype.reset = function () {
        this._cameraEventDistribution.reset();
        this._cameraLogic.reset();
    };
    OrbitControlsManager.prototype.restrict = function (position, target) {
        return this._cameraLogic.restrict(position, target);
    };
    OrbitControlsManager.prototype.update = function (time, manualInteraction) {
        this._cameraLogic.update(time, manualInteraction);
    };
    return OrbitControlsManager;
}());
exports.OrbitControlsManager = OrbitControlsManager;
;
